


import { defineComponent, onMounted, ref, onBeforeUnmount, onUnmounted,computed } from 'vue';
import { MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import DropDownTypeConst from '../../../../domain/Constants/DropDownTypeConst';
import { Container } from 'inversify';
import BaseControlTypeConst from '../../../../domain/Constants/BaseControlTypeConst';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import { IapCatalogType } from '../../../../../catalog/domain/iapCatalogType';
import CustomValidate from '../../shared/CustomValidate.vue';
import { Dictionary } from '../../../../../expression/domain/dictionary';
import CatalogEventConst from '../../../../../catalog/domain/const/CatalogEventConst';
import { useStore } from 'vuex';	

export default defineComponent({
    name: 'dynamic_drop_down',
    components: {
        CustomValidate
    },
    props:
    {

        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },
    },
    setup(props, context) {
        //

        
        const store = useStore();
        const { vmodel, getPropertyValue,getPropertyValueOption, getPropertyValueOptions, getPropertyBooleanValue, loaded, componentData, resolveExpressions, baseOnBeforeUnmount, baseOnMounted, baseOnUnmount, v$, submitted, canEdit,isValidData,fieldKey,fieldKeyComponentDataSourceId,processEventComponent } = ComponentCommon(props, context,store);


        const clickf = ref(new Function());

        const clicktest = () => {
            // eval(' showMessage("click del boton"); alert("hola");')
        }
        const showMessage = (msg: string) => {
            MessageService.showToast(MessageType.Correcto, '', msg)
        }

        const getInputStyle = computed(() => {

        let inputStyleObj:any={};

        if(getPropertyBooleanValue(DropDownTypeConst.READONLY) ){
            inputStyleObj.readonly=true;
        }

        return inputStyleObj;
        })


        onMounted(() => {
            baseOnMounted();
        })

        onBeforeUnmount(() => {
            baseOnBeforeUnmount();
        })

        onUnmounted(() => {
            baseOnUnmount();
        })


        return {
            clickf,
            MessageService,
            MessageType,
            showMessage,
            clicktest,
            getPropertyValue,
            getPropertyValueOptions,
            getPropertyBooleanValue,
            vmodel,
            DropDownTypeConst,
            loaded,
            BaseControlTypeConst,
            v$,
            submitted,
            canEdit,
            isValidData,
            fieldKey,
            fieldKeyComponentDataSourceId,
            getPropertyValueOption,
            processEventComponent,
            CatalogEventConst,
            getInputStyle

        };
    },
});
